'use client';

import { createContext, useContext } from 'react';

export interface PageContextValues {
  accent: boolean;
  heroBleedSize: 'none' | 'sm' | 'md';
}

export const PageContext = createContext<PageContextValues>({
  accent: false,
  heroBleedSize: 'none',
});

export const usePageContext = () => {
  const context = useContext(PageContext);

  if (context === null) {
    throw new Error('usePageContext must be used within PageContainer');
  }

  return context;
};
